/** Společný soubor pro speciální validátory pro různá políčka v administraci */
namespace Gordic.Adm.WebControls.GAdmUtilsValidators {
    /**
     * Pouzito: DetailAdeKnihaPLA
     * */
    export function SpecialValidatorSchvalovaciRole(): Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> {
        var validator = new Gordic.Validators.Base({ message: "jres:33000393" }) //RC 33000393 : Hodnota není v pořádku.
        validator.validate = (value, source) => {
            if (value) {
                if (value.ktg_sch_role != null && value.ktg_sch_role != undefined) {
                    if (value.ktg_sch_role != 180)
                        return false
                }
                if (value.aktivita != null && value.aktivita != undefined) {
                    if (value.aktivita == 100)
                        return true;
                }
                return false;
            } else {
                return true;
            }
        }
        validator.stopping = true;
        return validator;
    }
}
